<template>
  <section class="token-section">
    <div class="token-container">
      <div class="token-header">
        <h2 class="token-title">{{translations[locale].title }}</h2>
        <p class="token-subtitle">{{ translations[locale].subtitle }}</p>
      </div>
      <div class="token-cards">
        <div class="token-card">
          <img src="@/assets/img/st_img1.png" alt="DeFi" class="card-image" />
          <div class="card-overlay">
            <div class="card-content">
              <h3>{{ translations[locale].features.defi.title }}</h3>
              <p>{{ translations[locale].features.defi.description }}</p>
              <button class="btn-learn-more">{{ translations[locale].learnMore }}</button>
            </div>
          </div>
        </div>
        <div class="token-card">
          <img src="@/assets/img/st_img2.png" alt="NFT" class="card-image" />
          <div class="card-overlay">
            <div class="card-content">
              <h3>{{ translations[locale].features.nft.title }}</h3>
              <p>{{ translations[locale].features.nft.description }}</p>
              <button class="btn-learn-more">{{ translations[locale].learnMore }}</button>
            </div>
          </div>
        </div>
        <div class="token-card">
          <img src="@/assets/img/st_img3.png" alt="DAO" class="card-image" />
          <div class="card-overlay">
            <div class="card-content">
              <h3>{{ translations[locale].features.dao.title }}</h3>
              <p>{{ translations[locale].features.dao.description }}</p>
              <button class="btn-learn-more">{{ translations[locale].learnMore }}</button>
            </div>
          </div>
        </div>
        <div class="token-card">
          <img src="@/assets/img/st_img4.png" alt="GameFi" class="card-image" />
          <div class="card-overlay">
            <div class="card-content">
              <h3>{{ translations[locale].features.gamefi.title }}</h3>
              <p>{{ translations[locale].features.gamefi.description }}</p>
              <button class="btn-learn-more">{{ translations[locale].learnMore }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from '@/stores/language'

const store = useStore()
const locale = computed(() => store.locale)

const translations = {
  zh: {
    title: '生態系統',
subtitle: 'KOMA生態系統涵蓋DeFi、NFT、DAO等多個領域,為用戶提供全方位的區塊鏈服務',
learnMore: '瞭解更多',
features: {
defi: {
title: 'DeFi金融',
description: '去中心化借貸、流動性挖礦、收益聚合器'
},
nft: {
title: 'NFT市場',
description: '數位藝術品交易、遊戲資產、虛擬物品'
},
dao: {
title: 'DAO治理',
description: '社區治理、提案投票、激勵機制'
},
gamefi: {
title: 'GameFi',
description: '區塊鏈遊戲、遊戲資產交易、 Play to Earn'
}
}
  },
  en: {
    title: 'Ecosystem',
    subtitle: 'The KOMA ecosystem covers multiple areas including DeFi, NFT, and DAO, providing comprehensive blockchain services for users',
    learnMore: 'Learn More',
    features: {
      defi: {
        title: 'DeFi Finance',
        description: 'Decentralized lending, liquidity mining, yield aggregators'
      },
      nft: {
        title: 'NFT Marketplace',
        description: 'Digital art trading, gaming assets, virtual items'
      },
      dao: {
        title: 'DAO Governance',
        description: 'Community governance, proposal voting, incentive mechanisms'
      },
      gamefi: {
        title: 'GameFi',
        description: 'Blockchain gaming, gaming asset trading, Play to Earn'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.token-section {
  padding: 96px 0;
  position: relative;
}

.token-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 32px;
}

.token-header {
  text-align: center;
  margin-bottom: 48px;
}

.token-title {
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  font-weight: 700;
  line-height: 1.2;
  color: #F8FAFC;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #60A5FA 0%, #A78BFA 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  letter-spacing: 0.05em;
}

.token-subtitle {
  font-size: clamp(0.875rem, 1.5vw, 1rem);
  color: #4B5563;
  line-height: 1.5;
  max-width: 672px;
  margin: 0 auto;
}

.token-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  margin-top: 48px;
}

.token-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 4/5;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);

    .card-overlay {
      background: linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 100%);
    }
  }
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px;
  background: linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
  transition: background 0.3s ease;
}

.card-content {
  color: #FFFFFF;
}

.card-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.card-content p {
  font-size: 1rem;
  line-height: 1.5;
  opacity: 0.8;
  margin-bottom: 1rem;
}

.btn-learn-more {
  padding: 8px 24px;
  background: #FFFFFF;
  color: #6366F1;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #F3F4F6;
    transform: translateY(-1px);
  }
}

// 响应式设计
@media screen and (max-width: 1200px) {
  .token-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
}

@media screen and (max-width: 768px) {
  .token-section {
    padding: 60px 0;
  }

  .token-container {
    padding: 0 24px;
  }

  .token-cards {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
  }

  .token-card {
    aspect-ratio: 16/9;
  }
}

@media screen and (max-width: 480px) {
  .token-section {
    padding: 40px 0;
  }

  .token-container {
    padding: 0 16px;
  }

  .card-overlay {
    padding: 24px;
  }
}

// 深色模式支持
@media (prefers-color-scheme: dark) {
  .token-subtitle {
    color: #9CA3AF;
  }

  .btn-learn-more {
    background: #374151;
    color: #60A5FA;

    &:hover {
      background: #4B5563;
    }
  }
}
</style>